import { createContext } from "react";

export interface UserContextProps {
    user: string;
    setUser: (user: string) => void;
}

export const UserContext = createContext<UserContextProps>(
    {} as UserContextProps,
);
